import { render, staticRenderFns } from "./NewIrrigationUpkeep.vue?vue&type=template&id=0fca0180&scoped=true&lang=html&"
import script from "./NewIrrigationUpkeep.vue?vue&type=script&lang=js&"
export * from "./NewIrrigationUpkeep.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0fca0180",
  null
  
)

export default component.exports